import { useEffect, useRef } from "react";
import { NavLink, useInRouterContext } from "react-router-dom";
import TitleAnnulmentsManager from "./TitleAnnulmentsManager";

export {
  CATEGORY_LABELS,
  MAX_NUMBERS,
  REASON_MAX,
  REASON_MIN,
  STATUS_LABELS,
  formatRetryTime,
  parseNumbers,
  updateOutcome,
} from "./TitleAnnulmentsManager";

// Barra lateral "Títulos anulados na Ampli" (design D6): o diálogo (foco, Tab preso, Escape) em
// volta do mesmo `TitleAnnulmentsManager` da página "Títulos > Títulos anulados", com os
// valores da obra aberta. Abre pelo card, pelo indicador e pelo menu da obra.
const TitleAnnulmentsOffcanvas = ({ open, onClose, projectId, status, data, project, erp, reload }) => {
  // Fora de um Router (testes de componente) o atalho para a página não aparece. A checagem do
  // tipo cobre os testes que trocam o react-router-dom por um mock parcial.
  const inRouter = typeof useInRouterContext === "function" ? useInRouterContext() : false;
  useEffect(() => {
    if (!open) return undefined;
    const handleEscape = (event) => {
      if (event.key !== "Escape") return;
      event.preventDefault();
      onClose?.();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [open, onClose]);

  // Foco: ao abrir vai para o diálogo e, ao fechar, volta para quem abriu. Tab fica dentro dele.
  const dialogRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const opener = document.activeElement;
    dialogRef.current?.focus();
    return () => {
      if (opener && typeof opener.focus === "function" && document.contains(opener)) opener.focus();
    };
  }, [open]);

  const trapTab = (event) => {
    if (event.key !== "Tab" || !dialogRef.current) return;
    const focusable = [...dialogRef.current.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])',
    )];
    if (focusable.length === 0) {
      event.preventDefault();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || active === dialogRef.current)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  };

  if (!open) return null;

  return (
    <div className="offcanvas active">
      <div
        ref={dialogRef}
        tabIndex={-1}
        onKeyDown={trapTab}
        className="offcanvas-container large cost-origin-titles-surface ta-offcanvas"
        role="dialog"
        aria-modal="true"
        aria-label="Títulos anulados na Ampli"
      >
        <hgroup className="offcanvas-header">
          <h2>Títulos anulados na Ampli</h2>
          <button onClick={onClose} aria-label="Fechar">
            <i className="icon icon-width-24 icon-times background-accent" aria-hidden={true}></i>
          </button>
        </hgroup>
        <div className="offcanvas-content">
          {inRouter && projectId && (
            <NavLink className="ta-link ta-offcanvas__page-link" to={`/dashboard/titulos-anulados/${projectId}`} onClick={onClose}>
              Abrir a lista completa da construtora
            </NavLink>
          )}
          <TitleAnnulmentsManager
            variant="offcanvas"
            projectId={projectId}
            status={status}
            data={data}
            project={project}
            erp={erp}
            reload={reload}
          />
        </div>
      </div>
      <div onClick={onClose} className="offcanvas-background" />
    </div>
  );
};

export default TitleAnnulmentsOffcanvas;
